import React, { useState, useEffect } from "react";
import PathLink from "../../shared/seo/PathLink";
import { useBlogContext } from "../../shared/context/BlogContext";
import { urls } from "../../shared/seo/links";
import { useTranslation } from "react-i18next";
import PostCard from "./PostCard";
import ComponentsLoader from "../../components/includes/ComponentsLoader";

export default function BlogSection() {
  const { t } = useTranslation();
  const Lng = localStorage.getItem("lang");
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getBlogsByFilter } = useBlogContext();
  useEffect(() => {
    async function fetchBlogs() {
      const response = await getBlogsByFilter({
        limit: 4,
        filters: [{ language: Lng, status: "published" }],
      });
      setBlogs(response.data?.blogs ?? []);
      setIsLoading(false);
    }
    fetchBlogs();
  }, []);

  return (
    <section className="section section-blogs">
      <div className="container-fluid">
        <div className="section-header text-center aos aos-init aos-animate">
          <h2>{t("Legal_Magazine_title")}</h2>
          <p className="sub-title">{t("Legal_Magazine_description")}</p>
        </div>
        <div
          style={{ marginTop: "20px" }}
          className="row blog-grid-row aos aos-init aos-animate"
        >
          {isLoading ? (
            <ComponentsLoader />
          ) : blogs?.length > 0 ? (
            blogs.map((blog) => {
              return <PostCard key={blog._id || blog.id} blog={blog} />;
            })
          ) : null}
        </div>
        <div className="row blog-grid-row aos aos-init aos-animate"></div>
        <div className="view-all text-center aos aos-init aos-animate">
          {/* A real link (crawlable), styled as the design-system outline button:
              the template's .btn-primary is fought over by !important rules. */}
          <PathLink to={urls.sectionPath("blogs", Lng)} className="avc-btn avc-btn--outline">
            {t("View_All_blog")}
          </PathLink>
        </div>
      </div>
    </section>
  );
}
